/* Crochet the Day - light interactions */
(function(){
  // Mobile nav
  var toggle=document.querySelector('[data-menu-toggle]');
  var nav=document.querySelector('[data-mobile-nav]');
  var overlay=document.querySelector('[data-overlay]');
  function closeNav(){nav&&nav.classList.remove('open');overlay&&overlay.classList.remove('open');}
  if(toggle&&nav){toggle.addEventListener('click',function(){nav.classList.toggle('open');overlay.classList.toggle('open');});}
  if(overlay){overlay.addEventListener('click',closeNav);}

  // Product gallery thumbs
  document.querySelectorAll('[data-thumb]').forEach(function(t){
    t.addEventListener('click',function(){
      var main=document.querySelector('[data-main-image]');
      if(main){main.src=t.getAttribute('data-full')||t.src;main.srcset='';}
      document.querySelectorAll('[data-thumb]').forEach(function(x){x.setAttribute('aria-current','false');});
      t.setAttribute('aria-current','true');
    });
  });

  // FAQ: allow only one open (optional nicety) - leave native for accessibility

  // Notify form: friendly inline success (progressive enhancement over Shopify form)
  document.querySelectorAll('form.notify-form').forEach(function(f){
    f.addEventListener('submit',function(){
      // Shopify handles the POST; show optimistic message
      var msg=f.querySelector('[data-notify-success]');
      if(msg){setTimeout(function(){msg.hidden=false;},50);}
    });
  });
})();

/* Crochet the Day - AJAX cart drawer (progressive enhancement) */
(function(){
  var drawer=document.querySelector('[data-cart-drawer]');
  if(!drawer){return;}
  var overlay=document.querySelector('[data-overlay]');
  var lines=drawer.querySelector('[data-cart-lines]');
  var foot=drawer.querySelector('[data-cart-foot]');
  var totalEl=drawer.querySelector('[data-cart-total]');
  var checkoutBtn=drawer.querySelector('[data-cart-checkout]');
  if(checkoutBtn){checkoutBtn.setAttribute('href','/checkout');}

  function money(c){return '£'+(c/100).toFixed(2);}
  function openDrawer(){drawer.classList.add('open');if(overlay){overlay.classList.add('open');}document.body.classList.add('no-scroll');drawer.setAttribute('aria-hidden','false');}
  function closeDrawer(){drawer.classList.remove('open');if(overlay){overlay.classList.remove('open');}document.body.classList.remove('no-scroll');drawer.setAttribute('aria-hidden','true');}

  function render(cart){
    if(!cart){return;}
    document.querySelectorAll('.cart-count').forEach(function(el){el.textContent=cart.item_count;el.style.display=cart.item_count>0?'':'none';});
    if(!lines){return;}
    if(cart.item_count===0){
      lines.innerHTML='<p class="cart-drawer__empty">Your basket is empty.</p>';
      if(foot){foot.style.display='none';}
      return;
    }
    if(foot){foot.style.display='';}
    var html='';
    cart.items.forEach(function(it,i){
      html+='<div class="cd-line" data-line="'+(i+1)+'">'
        +'<a href="'+it.url+'" class="cd-thumb">'+(it.image?'<img src="'+it.image+'" alt="" width="72" height="72">':'')+'</a>'
        +'<div class="cd-mid"><a href="'+it.url+'" class="cd-title">'+it.product_title+'</a>'
        +'<div class="cd-price">'+money(it.final_price)+'</div>'
        +'<div class="cd-qty"><button type="button" data-dec aria-label="Decrease">&minus;</button><span>'+it.quantity+'</span><button type="button" data-inc aria-label="Increase">+</button>'
        +'<button type="button" data-remove class="cd-remove">Remove</button></div></div>'
        +'<div class="cd-lt">'+money(it.final_line_price)+'</div></div>';
    });
    lines.innerHTML=html;
    if(totalEl){totalEl.textContent=money(cart.total_price);}
  }

  function fetchCart(cb){fetch('/cart.js',{headers:{'Accept':'application/json'}}).then(function(r){return r.json();}).then(function(c){render(c);if(cb){cb(c);}});}
  function change(line,qty){fetch('/cart/change.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({line:line,quantity:qty})}).then(function(r){return r.json();}).then(render);}

  document.querySelectorAll('[data-product-form]').forEach(function(form){
    form.addEventListener('submit',function(e){
      var s=e.submitter;
      if(s && s.getAttribute('name')!=='add' && !s.hasAttribute('data-add-to-cart')){return;}
      e.preventDefault();
      var btn=form.querySelector('[data-add-to-cart]');
      var label=btn?btn.innerHTML:'';
      if(btn){btn.disabled=true;btn.innerHTML='Adding…';}
      fetch('/cart/add.js',{method:'POST',headers:{'Accept':'application/json'},body:new FormData(form)})
        .then(function(r){if(!r.ok){throw new Error('add failed');}return r.json();})
        .then(function(){fetchCart(function(){openDrawer();});})
        .catch(function(){form.submit();})
        .then(function(){if(btn){btn.disabled=false;btn.innerHTML=label;}});
    });
  });

  document.querySelectorAll('[data-cart-toggle]').forEach(function(a){
    a.addEventListener('click',function(e){e.preventDefault();fetchCart(function(){openDrawer();});});
  });
  drawer.querySelectorAll('[data-cart-close]').forEach(function(b){b.addEventListener('click',closeDrawer);});
  if(overlay){overlay.addEventListener('click',closeDrawer);}
  document.addEventListener('keydown',function(e){if(e.key==='Escape'){closeDrawer();}});

  if(lines){lines.addEventListener('click',function(e){
    var lineEl=e.target.closest('[data-line]');if(!lineEl){return;}
    var line=parseInt(lineEl.getAttribute('data-line'),10);
    var span=lineEl.querySelector('.cd-qty span');
    var q=span?parseInt(span.textContent,10):1;
    if(e.target.closest('[data-inc]')){change(line,q+1);}
    else if(e.target.closest('[data-dec]')){change(line,Math.max(0,q-1));}
    else if(e.target.closest('[data-remove]')){change(line,0);}
  });}

  fetchCart();
})();
